export default __webpack_public_path__ + "static/media/Avianca.673bb8d1.png";